import { useRuntimeConfig } from '#app';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

export const checkIfIsPasswordProtected = (route: RouteLocationNormalizedGeneric): boolean => {
  const { passwordProtected } = useRuntimeConfig().public;
  const cookiePassword = useCookie('password-protected');
  const { isLivePreview } = useLivePreview();
  return passwordProtected && (!cookiePassword || (cookiePassword.value !== passwordProtected && !isLivePreview(route)));
};
